import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  h3 {
    color: #5d5d5d;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .w-17 {
    width: 17%;
  }

  .default {
    max-width: 64px;
    max-height: 64px;
    border: solid 1px #002f6c;
    border-radius: 4px;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 204, 0, 1);
      background-color: #ffcc00;
    }
    50% {
      box-shadow: 0 0 0 10px rgba(255, 204, 0, 0.2);

      background-color: #ff842f;
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 204, 0, 0);
      background-color: #ffcc00;
    }
  }

  @keyframes hightlight {
    0% {
      fill: #000;
    }
    50% {
      fill: #fff;
    }
    100% {
      fill: #000;
    }
  }

  .bg-check {
    padding: 4px 8px;
    height: 32px;
    width: 32px;
    display: inline-block;
    animation: pulse 1s infinite;
    svg {
      animation: hightlight 1s infinite;
    }
  }

  .bg-orange {
    background-color: #ff842f;
    padding: 4px 8px;
    height: 32px;
    width: 32px;
    display: inline-block;
  }

  .mkt {
    color: #fff;
    background-color: #ff842f;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
  }

  button.mkt[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const Status = styled.p<IStatus>`
  color: ${(props) => {
    switch (props.status) {
      case 'Em Alteração':
      case 'Fim Inscrições':
      case 'Em Andamento':
      case 'Cadastrando':
        return '#000';
      default:
        return '#fff';
    }
  }}!important;
  background-color: ${(props) => {
    switch (props.status) {
      case 'Cadastrando':
        return '#bbb';
      case 'Rascunho':
        return '#4b4b4d';
      case 'Em Alteração':
        return '#dbb100';
      case 'A Publicar':
        return '#674ea7';
      case 'Aprovado':
        return '#dbb100';
      case 'Aberto':
        return '#427242';
      case 'Fim Inscrições':
        return '#ff9900';
      case 'Fechado':
        return '#20124d';
      case 'Em Andamento':
        return '#00ffff';
      case 'Encerrado':
        return '#002f6c';
      case 'Finalizado':
        return '#20124d';
      case 'Cancelado':
        return '#bf2216';
      case 'Esgotado':
        return '#f00';
      default:
        return '#000';
    }
  }};
  padding: 3px;
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 500;
  }

  input {
    color: #202020;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
  }

  input::placeholder {
    color: #d8d8d8;
  }

  button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  label {
    span {
      color: #000;
    }
  }

  .check {
    color: #6a6a6a;
    font-size: 14px;
    font-weight: 500;
    > span:nth-child(1) {
      border-radius: 4px;
      border: 1px solid #c7c7c7;
      min-width: 24px;
      height: 24px;
    }
  }

  .checked {
    background: #ff842f !important;
  }

  .check-list {
    height: 17px !important;
    width: 17px !important;
  }

  .input {
    border: 1px solid rgba(221, 221, 221, 0.87);

    height: 40px;
    border-radius: 4px;

    input {
      color: #202020;
    }
  }

  .btn-filter {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }
`;
